export const USER_QUERY_KEYS = { user: () => ['user'] as const };
